// @flow

import * as React from 'react';
import { localize, unescaped } from '@ta/common.i18n';
import { EscapeHtml } from '@ta/common.text';
import { getDisplayName } from '@ta/social.member';
import classNames from '@ta/common.classnames';

import styles from './SponsoredCrust.less';

type Route = {|
  /** Url of the route */
  url: string,
|};

type UserProfile = {|
  /** Display name of the user */
  displayName: string,
  /** Route of the user profile */
  route: Route,
  /** Like the blue twitter check mark except green for tripadvisor */
  isVerified: boolean,
|};

export type Sponsorship = {
  /** the optional profile that the content is sponsored by */
  userProfile?: UserProfile,
};

type Props = {
  /** the sponsorship object. if it isn't here, don't show the crust */
  sponsorship?: Sponsorship,
  /** flag that doesn't exist yet that should exist if we want to show the userprofile */
  showUserProfile?: boolean,
};

const SponsoredCrust = ({ sponsorship, showUserProfile }: Props) => {
  if (!sponsorship) {
    return null;
  }
  const { userProfile } = sponsorship;
  if (userProfile && showUserProfile) {
    const memberLinkClass = classNames('ui_link', styles.member, {
      verified: userProfile.isVerified,
    });
    const messageParams = {
      '0': memberLinkClass,
      '1': userProfile?.route?.url,
      '2': EscapeHtml(getDisplayName(userProfile)),
    };
    return (
      <div className={styles.sponsored_crust}>
        {unescaped(localize('provided_by_username', messageParams))}
      </div>
    ); // Provided by USERNAME
  }
  return <div className={styles.sponsored_crust}>{localize('discovery_sponsored_label')}</div>; // Sponsored
};

export default SponsoredCrust;
